// extracted by mini-css-extract-plugin
export default {"Main":"HomeTabDropdown_Main__9-PpN","List":"HomeTabDropdown_List__BrXPl","Item":"HomeTabDropdown_Item__Cca4t","Selected":"HomeTabDropdown_Selected__GNwW+"};